// src/components/Navigation.jsx - WITH DEBUG TAB
import React from 'react';
import { Camera, Layers, Trophy, Scroll } from 'lucide-react';

export const Navigation = ({ view, setView }) => {
  const navItems = [
    {id:'mint',label:'MINT',icon:Camera},
    {id:'stake',label:'STAKE',icon:Layers},
    {id:'rewards',label:'REWARDS',icon:Trophy},
    {id:'mythology',label:'MYTHOLOGY',icon:Scroll}
  ];
  
  return (
    <nav className="border-t-4 border-b-4 border-white bg-black mt-8">
      <div className="max-w-7xl mx-auto flex">
        {navItems.map((item, index) => {
          const Icon = item.icon;
          const isActive = view === item.id;
          return (
            <button 
              key={item.id} 
              onClick={() => setView(item.id)}
              className={`flex-1 py-4 font-black text-sm uppercase font-mono border-r-4 border-white last:border-r-0 flex items-center justify-center gap-2 transition-all duration-200
                ${isActive 
                  ? 'bg-green-400 text-black' 
                  : 'bg-black text-white hover:bg-white hover:text-black'
                }`}
            >
              <Icon size={20} />
              <span className="hidden sm:inline">{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};